export default __webpack_public_path__ + "static/media/icon-search.0cc0c984.svg";